/* milnovecientostres · colores y etiquetas en tarjetas + barra de envío gratis en el carrito */
(function () {
  var el = document.getElementById('mapa-1903');
  var M = {};
  try { M = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { M = {}; }
  var P = M.p || {}, G = M.g || [];
  var HEX = { 'negro': '#141414', 'negro (logo rojo)': '#141414', 'negro (logo blanco)': '#141414', 'blanco': '#f6f6f4', 'crema': '#ebe3d2', 'gris': '#b9b9bb', 'gris lavado': '#5f6061', 'marino': '#1e2b4b', 'azul': '#264796', 'rojo': '#c8102e', 'teja': '#b6532d', 'granate': '#6b1d27' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DIAS_NUEVO = 45;

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function procesarTarjetas() {
    var cards = document.querySelectorAll('.card-wrapper:not([data-c1903])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.setAttribute('data-c1903', '1');
      var a = c.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var h = handleOf(a), info = P[h];
      if (!info) continue;
      // Etiquetas
      var tags = [];
      if (info[3] === 1) tags.push(['Más vendido', 'mas-vendido']);
      if (info[4]) {
        var dias = (Date.now() - new Date(info[4]).getTime()) / 86400000;
        if (dias < DIAS_NUEVO) tags.push(['Nuevo', 'nuevo']);
      }
      var inner = c.querySelector('.card__inner');
      if (tags.length && inner && !inner.querySelector('.e1903')) {
        var t = document.createElement('div');
        t.className = 'e1903 e1903--tarjeta';
        t.innerHTML = tags.slice(0, 2).map(function (x) { return '<span class="e1903__tag e1903__tag--' + x[1] + '">' + x[0] + '</span>'; }).join('');
        inner.appendChild(t);
      }
      // Puntos de color
      if (info[0] >= 0 && G[info[0]]) {
        var hs = G[info[0]];
        var ci = c.querySelectorAll('.card-information'); var hl = c.querySelectorAll('.card__heading');
        var heading = ci.length ? ci[ci.length - 1] : (hl.length ? hl[hl.length - 1] : null);
        if (heading && !c.querySelector('.c1903c')) {
          var d = document.createElement('div');
          d.className = 'c1903c';
          var html = '';
          hs.slice(0, 5).forEach(function (hh) {
            var n = (P[hh] && P[hh][1]) || '';
            html += '<a href="' + root + 'products/' + hh + '" data-h="' + hh + '" class="c1903c__dot' + (hh === h ? ' is-active' : '') + '" title="' + n + '" aria-label="' + n + '" style="background:' + (HEX[n.toLowerCase()] || '#ccc') + '"></a>';
          });
          if (hs.length > 5) html += '<span class="c1903c__more">+' + (hs.length - 5) + '</span>';
          html += '<span class="c1903c__txt">' + hs.length + ' colores</span>';
          d.innerHTML = html;
          heading.insertAdjacentElement('afterend', d);
        }
      }
    }
  }

  // Barra de envío gratis en el carrito lateral
  var UMBRAL = 7000;
  function eur(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  var pidiendo = false;
  function barraEnvio() {
    var drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawer || pidiendo) return;
    pidiendo = true;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      pidiendo = false;
      var old = drawer.querySelector('.fs1903'); if (old) old.remove();
      if (!cart || !cart.item_count) return;
      var falta = UMBRAL - cart.total_price, pct = Math.min(100, Math.round(cart.total_price * 100 / UMBRAL));
      var b = document.createElement('div');
      b.className = 'fs1903' + (falta <= 0 ? ' is-done' : '');
      b.innerHTML = (falta > 0 ? '<p>Te faltan <strong>' + eur(falta) + '</strong> para el <strong>envío gratis</strong></p>' : '<p>¡Ya tienes el <strong>envío gratis</strong>!</p>') +
        '<div class="fs1903__bar" role="progressbar" aria-label="Progreso hacia el envío gratis" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
      var head = drawer.querySelector('.drawer__header');
      if (head) head.insertAdjacentElement('afterend', b); else drawer.prepend(b);
    }).catch(function () { pidiendo = false; });
  }

  // Traducción de las opciones en el carrito (size/color en inglés por la sincronización)
  var OPC = { 'size': 'Talla', 'color': 'Color', 'colour': 'Color', 'title': '' };
  var COL = { 'black': 'Negro', 'black beauty': 'Negro', 'lucent white': 'Blanco', 'white': 'Blanco', 'navy blue': 'Azul marino', 'navy blue with white': 'Azul marino y blanco', 'black with white': 'Negro y blanco', 'oat gray': 'Gris claro', 'flower gray': 'Gris jaspeado', 'red': 'Rojo', 'brick red': 'Teja', 'wine red': 'Granate', 'royal blue': 'Azul' };
  function traducirOpciones() {
    var dts = document.querySelectorAll('.product-option dt:not([data-t1903])');
    for (var i = 0; i < dts.length; i++) {
      var dt = dts[i]; dt.setAttribute('data-t1903', '1');
      var k = dt.textContent.replace(':', '').trim().toLowerCase();
      if (!(k in OPC)) continue;
      dt.textContent = OPC[k] ? OPC[k] + ': ' : '';
      if (k === 'color' || k === 'colour') {
        var dd = dt.nextElementSibling;
        if (dd) {
          var raw = dd.textContent.trim(), coma = /,$/.test(raw);
          var v = raw.replace(/,$/, '').trim().toLowerCase();
          if (COL[v]) dd.textContent = COL[v] + (coma ? ',' : '');
        }
      }
    }
  }


  // Al tocar un color en la tarjeta: se previsualiza ese color sin entrar en la ficha.
  // Segundo toque sobre el color activo (o sobre la foto) abre la ficha.
  var CACHE = {};
  function img(u, w) { return (u.indexOf('//') === 0 ? 'https:' + u : u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cambiarColor(card, dot) {
    var hh = dot.getAttribute('data-h');
    var aplicar = function (p) {
      var url = root + 'products/' + p.handle;
      var fotos = (p.images || []).slice(0, 4);
      card.querySelectorAll('a[href*="/products/"]:not(.c1903c__dot)').forEach(function (a) { a.setAttribute('href', url); });
      card.querySelectorAll('[data-product-url]').forEach(function (b) { b.setAttribute('data-product-url', url); });
      var main = card.querySelector('.card__media > .media img');
      if (main && fotos[0]) { main.removeAttribute('srcset'); main.src = img(fotos[0], 533); }
      var main2 = card.querySelectorAll('.card__media > .media img')[1];
      if (main2 && fotos[1]) { main2.removeAttribute('srcset'); main2.src = img(fotos[1], 533); }
      var tr = card.querySelector('.cs1903__track');
      if (tr && fotos.length) {
        tr.innerHTML = fotos.map(function (f) { return '<a href="' + url + '" class="cs1903__slide" tabindex="-1" aria-hidden="true"><img src="' + img(f, 533) + '" alt="" loading="lazy"></a>'; }).join('');
        tr.scrollLeft = 0;
        var dw = card.querySelector('.cs1903__dots');
        if (dw) dw.innerHTML = fotos.map(function (f, i) { return '<span' + (i ? '' : ' class="is-active"') + '></span>'; }).join('');
      }
      card.querySelectorAll('.c1903c__dot').forEach(function (x) { x.classList.toggle('is-active', x === dot); });
    };
    if (CACHE[hh]) return aplicar(CACHE[hh]);
    fetch(root + 'products/' + hh + '.js').then(function (r) { return r.json(); }).then(function (p) { CACHE[hh] = p; aplicar(p); }).catch(function () { location.href = dot.href; });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.c1903c__dot');
    if (!dot) return;
    if (dot.classList.contains('is-active')) return; // ya activo: abre la ficha
    e.preventDefault();
    cambiarColor(dot.closest('.card-wrapper'), dot);
  });

  // Puntos de las fotos deslizables en tarjetas (móvil)
  function fotosTarjetas() {
    var ss = document.querySelectorAll('[data-cs1903]:not([data-on])');
    for (var i = 0; i < ss.length; i++) {
      (function (s) {
        s.setAttribute('data-on', '1');
        var tr = s.querySelector('.cs1903__track');
        tr.addEventListener('scroll', function () {
          var ds = s.querySelectorAll('.cs1903__dots span');
          var n = Math.round(tr.scrollLeft / (tr.clientWidth || 1));
          for (var j = 0; j < ds.length; j++) ds[j].className = j === n ? 'is-active' : '';
        }, { passive: true });
      })(ss[i]);
    }
  }

  function init() {
    procesarTarjetas();
    traducirOpciones();
    fotosTarjetas();
    barraEnvio();
    var t;
    new MutationObserver(function (muts) {
      clearTimeout(t);
      t = setTimeout(function () {
        procesarTarjetas();
        traducirOpciones();
        fotosTarjetas();
        var cd = document.querySelector('#CartDrawer .drawer__inner');
        if (cd && !cd.querySelector('.fs1903')) barraEnvio();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(barraEnvio, 150); });
      }
    } catch (e) {}
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
